export default __webpack_public_path__ + "static/media/main.9be6e8f1.png";